import React from "react";
import { Card } from "antd/lib/index";
import { FieldArray } from "formik";
import EtapaForm from "./EtapaForm";

const EtapasInput = props => {
  const { values } = props;
  return (
    <Card style={{ margin: 50, backgroundColor: "gray" }}>
      <FieldArray
        name="etapas"
        render={() =>
          values.etapas &&
          values.etapas.map((etapa, index) => (
            <EtapaForm key={index} index={index} values={values} />
          ))
        }
      />
    </Card>
  );
};

export default EtapasInput;
